/** @jsxImportSource @emotion/react */
import Grid from "@mui/material/Grid";
import { useState } from "react";
import PropTypes from "prop-types";
import {
  ACTION_CANCEL,
  ACTION_APPROVE,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCEL_SUBMITTED,
  STATUS_EXPIRED_ADM,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
  ACTION_REINSTATE,
  ACTION_REFUSE,
  ACTION_CANCEL_APPROVE,
  ACTION_CANCEL_REFUSE,
  STATUS_CANCELED_EE,
} from "../util/constants.js";
import ActionButton from "./fundamentals/ActionButton.jsx";
import TimeOffRequestAdminActionCheckDialog from "./TimeOffRequestAdminActionCheckDialog.jsx";

const TimeOffRequestAdminAction = (props) => {
  const [isActionCheckDialogOpen, setIsActionCheckDialogOpen] = useState(false);
  const [actionSelected, setActionSelected] = useState("");

  const getStatusActions = (action, buttonText) => {
    return (
      <Grid container>
        <Grid item xs={6} md={12}>
          <ActionButton variant="contained" color="primary" onClick={() => handleActionClicked(action)}>
            {buttonText}
          </ActionButton>
        </Grid>
      </Grid>
    );
  };

  const getSubmittedStatusActions = () => {
    return (
      <Grid container>
        <Grid item xs={6} md={12}>
          <ActionButton variant="contained" color="primary" onClick={() => handleActionClicked(ACTION_APPROVE)}>
            {ACTION_APPROVE}
          </ActionButton>
        </Grid>
        <Grid item xs={6} md={12}>
          <ActionButton variant="contained" color="primary" onClick={() => handleActionClicked(ACTION_REFUSE)}>
            {ACTION_REFUSE}
          </ActionButton>
        </Grid>
      </Grid>
    );
  };

  const getCancelSubmittedStatusActions = () => {
    return (
      <Grid container>
        <Grid item xs={6} md={12}>
          <ActionButton variant="contained" color="primary" onClick={() => handleActionClicked(ACTION_CANCEL_APPROVE)}>
            {ACTION_APPROVE}
          </ActionButton>
        </Grid>
        <Grid item xs={6} md={12}>
          <ActionButton variant="contained" color="primary" onClick={() => handleActionClicked(ACTION_CANCEL_REFUSE)}>
            {ACTION_REFUSE}
          </ActionButton>
        </Grid>
      </Grid>
    );
  };

  const getActionsBasedOnStatus = (status) => {
    switch (status) {
      case STATUS_SUBMITTED:
        return getSubmittedStatusActions();
      case STATUS_APPROVED:
        return getStatusActions(ACTION_CANCEL, ACTION_CANCEL);
      case STATUS_EXPIRED_ADM:
        return getStatusActions(ACTION_REINSTATE, ACTION_REINSTATE);
      case STATUS_CANCEL_SUBMITTED:
        return getCancelSubmittedStatusActions();
      case STATUS_RETRACTED:
      case STATUS_REFUSED:
      case STATUS_CANCELED_ADM:
      case STATUS_CANCELED_EE:
        return <div></div>;
      default:
        return "uh oh";
    }
  };

  const handleActionClicked = (actionName) => {
    setActionSelected(actionName);
    handleClickDialogOpen();
  };

  const handleClickDialogOpen = () => {
    setIsActionCheckDialogOpen(true);
  };

  const handleClickDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setIsActionCheckDialogOpen(false);
  };

  return (
    <Grid
      sx={{
        lineHeight: "normal",
        textAlign: "left",
      }}
      data-testid="tor-admin-action"
    >
      {getActionsBasedOnStatus(props.timeOffRequest.visibleStatus)}
      {isActionCheckDialogOpen && (
        <TimeOffRequestAdminActionCheckDialog
          timeOffRequest={props.timeOffRequest}
          isDialogOpen={isActionCheckDialogOpen}
          actionSelected={actionSelected}
          onClickDialogClose={handleClickDialogClose}
          onTimeOffRequestDialogClose={props.onTimeOffRequestDialogClose ? props.onTimeOffRequestDialogClose : null}
        />
      )}
    </Grid>
  );
};

TimeOffRequestAdminAction.propTypes = {
  timeOffRequest: PropTypes.object.isRequired,
  onTimeOffRequestDialogClose: PropTypes.func,
};

export default TimeOffRequestAdminAction;
